
import React from 'react';
import { Table, Typography, Tag, Space, Button, Popconfirm, Tooltip } from 'antd';
import {
    QuestionCircleOutlined, BulbOutlined, ClockCircleOutlined, DeleteOutlined
} from '@ant-design/icons';
import type { RufusQA } from '../types';

const { Text, Paragraph } = Typography;

interface QATableProps {
    data: RufusQA[];
    loading: boolean;
    onDelete: (id: number) => void;
}

export const QATable: React.FC<QATableProps> = ({ data, loading, onDelete }) => {
    const columns = [
        {
            title: '问题',
            dataIndex: 'question',
            key: 'question',
            width: '30%',
            render: (text: string) => (
                <Space>
                    <QuestionCircleOutlined style={{ color: '#1890ff' }} />
                    <Text strong>{text}</Text>
                </Space>
            ),
        },
        {
            title: '分类',
            dataIndex: 'category',
            key: 'category',
            width: '10%',
            render: (text: string) => text ? <Tag color="blue">{text}</Tag> : <Text type="secondary">-</Text>
        },
        {
            title: '回答',
            dataIndex: 'answer',
            key: 'answer',
            render: (text: string, record: RufusQA) => (
                <div>
                    <Paragraph
                        ellipsis={{ rows: 3, expandable: true, symbol: '展开' }}
                        style={{ marginBottom: 8 }}
                    >
                        {text || <Text type="secondary">暂无回答</Text>}
                    </Paragraph>
                    {record.related_questions?.length > 0 && (
                        <div>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                <BulbOutlined /> 相关问题:
                            </Text>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
                                {record.related_questions.map((q, idx) => (
                                    <Tag key={idx} color="blue" style={{ fontSize: 11 }}>
                                        {q}
                                    </Tag>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            ),
        },
        {
            title: '抓取时间',
            dataIndex: 'scraped_at',
            key: 'scraped_at',
            width: 150,
            render: (time: string) => (
                <Tooltip title={new Date(time).toLocaleString()}>
                    <Space>
                        <ClockCircleOutlined />
                        <Text type="secondary">
                            {new Date(time).toLocaleDateString()}
                        </Text>
                    </Space>
                </Tooltip>
            ),
        },
        {
            title: '操作',
            key: 'action',
            width: 80,
            render: (_: any, record: RufusQA) => (
                <Popconfirm
                    title="确定删除这条问答吗？"
                    onConfirm={() => onDelete(record.id)}
                    okText="删除"
                    cancelText="取消"
                >
                    <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        size="small"
                    />
                </Popconfirm>
            ),
        },
    ];

    return (
        <Table
            dataSource={data}
            columns={columns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            size="small"
            loading={loading}
        />
    );
};
